import { SearchRequest } from '../../providers/request/search-request.model';
import { ProjectItemType } from './project-item-type.enum';

export class ProjectSectionUnitSearchRequest extends SearchRequest {
  projectId?: number;
  sectionId?: number;
  sectionItemId?: number;
  sectionItemType?: ProjectItemType;
  code?: string;
  fullCode?: string;
  projectTypeCode?: string;
  projectTypeName?: string;
  name?: string;
  highwayLevel?: string;
  mark?: string;
  constructionOrgName?: string;
  mileage?: string;
  dwMileage?: string;
  data1?: number;
  data2?: number;
  data3?: number;
  dwCode?: string;
  dwName?: string;
  dwSectionItemId?: number;
  subDwCode?: string;
  subDwName?: string;
  subDwSectionItemId?: number;
  fbCode?: string;
  fbName?: string;
  fbSectionItemId?: number;
  subFbCode?: string;
  subFbName?: string;
  subFbSectionItemId?: number;
  fxCode?: string;
  fxName?: string;
  fxAlias?: string;
  fxSectionItemId?: number;
  sub1FxCode?: string;
  sub1FxName?: string;
  sub1FxSectionItemId?: number;
  sub2FxCode?: string;
  sub2FxName?: string;
  sub2FxSectionItemId?: number;
  comment?: string;
  inRecycleBin?: boolean;
  hasLJ?: boolean;
}
